import { useRef, useEffect } from 'react';
const Resume = () => {
    let navOffsetTop = 0;
    const myResumeRef = useRef(null);
    const myWorkTableRef = useRef(null);
    let animate = [];
    let viewportHeight = window.innerHeight;
    let children = [];

    if (myResumeRef.current) {
        navOffsetTop = myResumeRef.current.offsetTop - viewportHeight;
        animate = myResumeRef.current.querySelectorAll('.animate');
        children = myWorkTableRef.current.children
    }
    
    window.addEventListener('scroll',()=>{
        if (window.scrollY>navOffsetTop) {
            Array.from(animate).forEach((item)=>{
                item.classList.add('expand');
            });
        } else {
            Array.from(animate).forEach((item)=>{
                item.classList.remove('expand');
            });
        }
    })

    function handleClick({target}) {
        let showItem = target.closest(".animate").dataset.resume;
        let myItem = myWorkTableRef.current.querySelector(`.${showItem}`);
        Array.from(children).forEach((item)=>(item.classList.remove('active')));
        myItem.classList.add('active');
    }

    return (
        <div className="component container-xl">

            <div className="time-slide" ref={myResumeRef} onClick={handleClick}>
                <div className="time-row date">
                    <div className="span-date">2004</div>
                    <div className="span-date">2016</div>
                    <div className="span-date">2018</div>
                    <div className="span-date">2021</div>
                    <div className="span-date">2023</div>
                </div>
                <div className="time-row">
                    <div className="span g1 animate" data-resume="contractor">
                        <div className="mobile-date">2004</div>
                        <div className="row-name">
                            <p>Contractor</p>
                            <div className="tridown"></div>
                        </div>
                    </div>
                </div>
                <div className="time-row">
                    <div className="span g2 animate" data-resume="visa">
                        <div className="mobile-date">2016</div>
                        <div className="row-name">
                            <p>Visa</p>
                            <div className="tridown"></div>
                        </div>
                    </div>
                </div>
                <div className="time-row">
                    <div className="span g3 animate" data-resume="liveramp">
                        <div className="mobile-date">2018</div>
                        <div className="row-name">
                            <p>Liveramp</p>
                            <div className="tridown"></div>
                        </div>
                    </div>
                </div>
                <div className="time-row">
                    <div className="span g4 animate" data-resume="william">
                        <div className="mobile-date">2021</div>
                        <div className="row-name">
                            <p>Williams Sonoma</p>
                            <div className="tridown"></div>
                        </div>
                    </div>
                </div>
                <div className="time-row">
                    <div className="span g5 animate" data-resume="luminii" >
                        <div className="mobile-date">2023</div>
                        <div className="row-name">
                            <a>Luminii</a>
                            <div className="tridown"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="resume" ref={myWorkTableRef}>
                <ul className="work-table luminii active">
                    <li className="date-table"><div>04/2024 – 12/2024</div></li>
                    <li className="company-name">Luminii</li>
                    <li className="job-title"><span>Title:</span> Senior Web Developer</li>
                    <li className="role"><span>Role:</span> Combine several independent websites into a single multi product brochure site</li>
                    <li className="employment"><span>Employment:</span> Full-time contractor</li>
                    <li className="skills"><span>Skills:</span> PHP, Apache, jQuery, HTML, JavaScript, CSS, MySql, Linux, Apache, WordPress, Figma, SASS, Github, Gulp Js</li>
                    <li className="desc">
                        <span>Description: <i className="right arrow"></i></span>
                        <div className="desc-text">
                            This was a full stack role that included extensive MySQl knowledge. I built a 1000 product website from Figma design comps. The site was installed into Wordpress. The extensive documentation required for each product
                            was stored in the cloud. The catalog pages contain filters built in Javascript. Extensive database and deep Wordpress knowledge was required to give the owners control over their extensive catalog.
                        </div>
                    </li>
                </ul>
                <ul className="work-table william">
                    <li className="date-table">03/2021 - 06/2023</li>
                    <li className="company-name">Williams Sonoma</li>
                    <li className="job-title"><span>Title:</span> Front-end Engineer</li>
                    <li className="role"><span>Role:</span> Website feature development</li>
                    <li className="employment"><span>Employment:</span> Full-time contractor</li>
                    <li className="skills">
                        <span>Skills:</span> Vue.js, JavaScript, Node.js, HTML, CSS, SASS, Webpack, Git, GitHub, Adobe Target, Adobe XD, Photoshop, Docker, E2E, Unit Testing: Vitest, Photoshop, Zeplin, Figma, Adobe XD, Responsive code, REST
                        APIs, Headless CMS
                    </li>
                    <li className="desc">
                        <span>Description: <i className="right arrow"></i></span>
                        <div className="desc-text">
                            <ul>
                                <li>Assisted in over 24 major releases over two years of Vue.js based updates to the main Williams Sonoma web code.</li>
                                <li>Implemented over 70 dynamic new features for Vue.js-based product pages on 7 Williams Sonoma websites.</li>
                                <li>
                                    Web features included banner images, text areas, price and discounts, product specifications, product variants, delivery information, promotional areas, product availability information, pop-out windows,
                                    type-ahead search, customer interaction, chat functions, live price updating based on user selections, carousels, and slideshows.
                                </li>
                                <li>Vue.js website pages including the homepages with customer-based variations, category list pages, product pages, shopping cart, checkout, and sales complete pages.</li>
                                <li>Interacted with REST APIs for standard CRUD operations to access production, sales, customer, and branding information as well as track customer progress and sales conversions.</li>
                                <li>Assisted in A/B testing of new pre-production features written in vanilla JavaScript and tested via Adobe Target.</li>
                                <li>Assisted in extensive Q/A testing of pre-production and productized features using unit and E2E testing</li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <ul className="work-table liveramp">
                    <li className="date-table">08/2018 - 03/2021</li>
                    <li className="company-name">Liveramp</li>
                    <li className="job-title"><span>Title:</span> In-house Web Developer</li>
                    <li className="role"><span>Role:</span> Maintain the company website</li>
                    <li className="employment"><span>Employment:</span> Full-time employee</li>
                    <li className="skills">
                        <span>Skills:</span> WordPress · Angular JS · Multi-site · HTML/CSS · Apache · Linux · SCSS · Git/GitHub · Webpack · Node.js · PHP · JavaScript · jQuery · MySQL · Photoshop · Zeplin · Figma · Adobe XD · Responsive code ·
                        REST APIs · Headless CMS
                    </li>
                    <li className="desc">
                        <span>Description: <i className="right arrow"></i></span>
                        <div className="desc-text">
                            <ul>
                                <li>Maintained 10 international WordPress installations with locations in North America, Asia, Europe, and Australia.</li>
                                <li>Re-engineered 8 separate websites into a single WordPress Multisite that allowed the marketing department to create and manage a network of multiple websites via a single WordPress dashboard.</li>
                                <li>Installed over 30 WordPress plugins to assist website management, maintenance, security, functionality, and content creation.</li>
                                <li>Created several custom WordPress plugins to allow the marketing department to extract and analyze data collected from customer website interactions.</li>
                                <li>Created 11 custom themes from graphic design comps to install into WordPress as marketing sites for company events.</li>
                                <li>Configured and installed Linux Apache servers to set up the web environments to host WordPress marketing websites.</li>
                                <li>Set up security software according to WordPress best practices to protect the website against hackers and malware.</li>
                                <li>Took care of all server and database maintenance tasks such as updating software, securing applications, and removing outdated functionality.</li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <ul className="work-table visa">
                    <li className="date-table ">08/2016 - 08/2018</li>
                    <li className="company-name">Visa</li>
                    <li className="job-title"><span>Title:</span> Lead Engineer and Architect</li>
                    <li className="role"><span>Role:</span> Design, build and manage a VISA website</li>
                    <li className="employment"><span>Employment:</span> Full-time contractor</li>
                    <li className="skills"><span>Skills:</span> PHP, Apache, Laravel MVC framework, jQuery, HTML, JavaScript, CSS, MySql, Linux, Apache, Eloquent ORM</li>
                    <li className="desc">
                        <span>Description: <i className="right arrow"></i></span>
                        <div className="desc-text">
                            <ul>
                                <li>Built a 700-page information website.</li>
                                <li>Built the site on top of the PHP Laravel framework.</li>
                                <li>Configured the server environment which included setting up Linux/Apache/MySQL/PHP and installing Laravel</li>
                                <li>Custom built security solutions to meet the considerable security requirements for Visa. The site needed to be protected against Cross-Site Request Forgery, Denial of Service, Brute Force Attacks etc.</li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <ul className="work-table contractor">
                    <li className="date-table">04/2005 - 08/2018</li>
                    <li className="company-name">Independent Contractor</li>
                    <li className="job-title"><span>Title:</span> Full Stack Web Developer</li>
                    <li className="role"><span>Role:</span> Design, build and manage websites</li>
                    <li className="employment"><span>Employment:</span> Self-employed freelancer</li>
                    <li className="skills">
                        <span>Skills:</span> WordPress, PHP, Apache, Laravel MVC framework, jQuery, HTML, JavaScript, CSS, MySQL, Linux, Apache, Eloquent ORM, AngularJs, VueJs, NodeJs, ReactJs, ExpressJs, Photoshop · Zeplin · Figma · Adobe XD ·
                        responsive coding · REST APIs · headless CMS, ecommerce, PHP plugin development, email coding, online forms, responsive design, Bootstrap, online security, website maintenance, landing pages, marketing campaigns, custom
                        PHP themes, server maintenance, hosting configuration, DNS configuration, data extraction and processing.
                    </li>
                    <li className="desc">
                        <span>Description: <i className="right arrow"></i></span>
                        <div className="desc-text">
                            <ul>
                                <li>
                                    Over 1000 + web projects [websites, web applications, widgets, server management, security implementation, database management] completed in 13 years comprising of websites, web applications, eCommerce
                                    systems, emails, and landing pages.
                                </li>
                                <li>I have been part of web development teams as both a lead programmer and a project manager.</li>
                                <li>I have full-stack skills in the LAMP environment that include server configuration, database management, database coding, front and back-end coding in PHP, HTML, CSS and JavaScript.</li>
                                <li>I've built large web applications with various MVC frameworks such as Laravel, Code Igniter and ColdBox (a Cold Fusion framework).</li>
                                <li>I'm an experienced WordPress programmer (custom themes and plugins) and have worked in content management systems such as Joomla.</li>
                                <li>I've also built, customized and managed eCommerce systems such as Magento, Xcart, Woocommerce.</li>
                                <li>I've built eCommerce systems from scratch for local startups.</li>
                                <li>Prominent clients (either directly employed or via intermediaries) that I have worked with/for over the years include Intercontinental Hotels, Visa, PG&amp;E, Qualcomm, Stanford University and Etrade.</li>
                                <li>
                                    I have worked with hundreds of smaller businesses around the country in industries such as real estate, catering, book sellers, software, law, charities and non-profits, solar, education, politics, finance,
                                    recruitment, art and many many more.
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Resume;